"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormService = void 0;
var CommonService_decorator_1 = require("../../decorators/CommonService.decorator");
var index_1 = require("../../index");
var User_service_1 = require("../User.service");
var Http_service_1 = require("../http/Http.service");
var JsonApi_service_1 = require("../jsonServiceApi/JsonApi.service");
var Cache_service_1 = require("../storage/Cache.service");
var FormService = /** @class */ (function () {
    function FormService(jsonApiService, userService, httpService, cacheService) {
        this.jsonApiService = jsonApiService;
        this.userService = userService;
        this.httpService = httpService;
        this.cacheService = cacheService;
    }
    FormService_1 = FormService;
    FormService.prototype.getWorkspaceFormRecord = function (formId, recordBlobId) {
        var _this = this;
        return this.jsonApiService.get('FormService', 'GetRecordFromStorage', {
            query: { formId: formId, recordBlobId: recordBlobId },
            retryCallback: function () { return _this.getWorkspaceFormRecord(formId, recordBlobId); },
        });
    };
    FormService.prototype.listRequestHistory = function (pageNumber, itemsPerPage) {
        var _this = this;
        return this.jsonApiService.get('FormService', 'GetLiveDocRequesterPagingData', {
            query: { pagenumber: pageNumber, itemsperpage: itemsPerPage, clienttype: this.userService.getLoginInfo().clientType },
            retryCallback: function () { return _this.listRequestHistory(pageNumber, itemsPerPage); },
        });
    };
    FormService.prototype.getDoccenterLiveDocHistory = function (data) {
        var _this = this;
        return this.jsonApiService.get('FormService', 'GetDoccenterLiveDocRequesterPagingData', {
            query: {
                contentobjectId: data.contentObjectId,
                pagenumber: data.pageIndex,
                itemsperpage: data.pageSize,
                clientType: this.userService.getLoginInfo().clientType,
            },
            retryCallback: function () { return _this.getDoccenterLiveDocHistory(data); },
        });
    };
    FormService.prototype.cancelGenerateRequest = function (requestId) {
        var _this = this;
        return this.jsonApiService.get('FormService', 'CancelLiveDocRequest', {
            query: { requestid: requestId },
            retryCallback: function () { return _this.cancelGenerateRequest(requestId); },
        });
    };
    FormService.prototype.removeGenerateRequest = function (requestId) {
        var _this = this;
        return this.jsonApiService.get('FormService', 'DeleteLiveDocRequest', {
            query: { requestid: requestId },
            retryCallback: function () { return _this.removeGenerateRequest(requestId); },
        });
    };
    FormService.prototype.getFormDefinition = function (sFormVersionId, suppressErr, formRecordBlobId) {
        var _this = this;
        return this.jsonApiService.get('FormService', 'GetFormDefinitionV2', {
            query: { id: sFormVersionId, clientType: this.userService.getLoginInfo().clientType, formRecordBlobId: formRecordBlobId },
            retryCallback: function () { return _this.getFormDefinition(sFormVersionId, suppressErr, formRecordBlobId); },
        });
    };
    FormService.prototype.getMiniFormDefinition = function (profileVersionId, versionId, profilePath) {
        var _this = this;
        return this.jsonApiService.get('FormService', profileVersionId ? 'GetMiniFormDefinition' : 'GetMiniFormDefinitionV2', {
            query: { profileVersionId: profileVersionId, versionid: versionId, profilePath: profilePath },
            retryCallback: function () { return _this.getMiniFormDefinition(profileVersionId, versionId, profilePath); },
        });
    };
    FormService.prototype.getAllRecords = function (formVersionId) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jsonApiService.get('FormService', 'RecordsV2', {
                        query: { formVersionId: formVersionId },
                        retryCallback: function () { return _this.getAllRecords(formVersionId); },
                    })];
            });
        });
    };
    FormService.prototype.getRecordById = function (formVersionId, recordId) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jsonApiService.get('FormService', 'GetRecord', {
                        query: { formVersionId: formVersionId, recordId: recordId },
                        retryCallback: function () { return _this.getRecordById(formVersionId, recordId); },
                    })];
            });
        });
    };
    FormService.prototype.shareRecord = function (recordId) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jsonApiService.get('FormService', 'ShareRecord', {
                        query: { recordId: recordId },
                        retryCallback: function () { return _this.shareRecord(recordId); },
                    })];
            });
        });
    };
    FormService.prototype.unshareRecord = function (recordId) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jsonApiService.get('FormService', 'UnshareRecord', {
                        query: { recordId: recordId },
                        retryCallback: function () { return _this.unshareRecord(recordId); },
                    })];
            });
        });
    };
    FormService.prototype.deleteRecord = function (formVersionId, recordId) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jsonApiService.get('FormService', 'DeleteRecord', {
                        query: { formVersionId: formVersionId, recordId: recordId },
                        retryCallback: function () { return _this.deleteRecord(formVersionId, recordId); },
                    })];
            });
        });
    };
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    FormService.prototype.requestContent = function (oRequestInput) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_b) {
                return [2 /*return*/, this.jsonApiService.post('FormService', 'RequestContentAsyncV2', oRequestInput, {
                        headers: FormService_1.isWorkspace() ? this.httpService.getGlobalHeaders((_a = this.cacheService.get('workspaceProfileVersionId')) === null || _a === void 0 ? void 0 : _a.value) : {},
                        retryCallback: function () { return _this.requestContent(oRequestInput); },
                    })];
            });
        });
    };
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    FormService.prototype.requestDocument = function (oRequestInput, suppressErr) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_b) {
                return [2 /*return*/, this.jsonApiService.post('FormService', 'RequestDocumentAsyncV2', oRequestInput, {
                        headers: FormService_1.isWorkspace() ? this.httpService.getGlobalHeaders((_a = this.cacheService.get('workspaceProfileVersionId')) === null || _a === void 0 ? void 0 : _a.value) : {},
                        query: {},
                        retryCallback: function () { return _this.requestDocument(oRequestInput, suppressErr); },
                    })];
            });
        });
    };
    /*
     * Post
     */
    FormService.prototype.checkRequestResult = function (sRequestId) {
        var _this = this;
        return this.jsonApiService.get('FormService', 'CheckRequestResult', {
            query: { requestid: sRequestId },
            retryCallback: function () { return _this.checkRequestResult(sRequestId); },
        });
    };
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    FormService.prototype.retrieveData = function (sformVersionId, isDeliveryOption, dataRefreshInput) {
        var _this = this;
        return this.jsonApiService.post('FormService', 'RetrieveFormDataV3', dataRefreshInput, {
            query: { id: sformVersionId, type: isDeliveryOption ? 'DeliveryOption' : '' },
            retryCallback: function () { return _this.retrieveData(sformVersionId, isDeliveryOption, dataRefreshInput); },
        });
    };
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    FormService.prototype.retrieveDataFromDataSource = function (sFormVersionId, isDeliveryOption, dataRefreshInput) {
        var _this = this;
        return this.jsonApiService.post('FormService', 'RetrieveDataFromDataSourceV2', dataRefreshInput, {
            query: { id: sFormVersionId, type: isDeliveryOption ? 'DeliveryOption' : '' },
            retryCallback: function () { return _this.retrieveDataFromDataSource(sFormVersionId, isDeliveryOption, dataRefreshInput); },
        });
    };
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    FormService.prototype.saveRecord = function (sFormVersionId, formRecord) {
        var _this = this;
        return this.jsonApiService.post('FormService', 'SaveRecord', formRecord, {
            query: { formVersionId: sFormVersionId },
            retryCallback: function () { return _this.saveRecord(sFormVersionId, formRecord); },
        });
    };
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    FormService.prototype.saveData = function (sRequestInput) {
        var _this = this;
        return this.jsonApiService.post('FormService', 'SaveDataV2', sRequestInput, {
            query: {},
            retryCallback: function () { return _this.saveData(sRequestInput); },
        });
    };
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    FormService.prototype.requestExcelDocument = function (oRequestInput, variableListName, documentName, isUploadData) {
        var _this = this;
        return this.jsonApiService.post('FormService', 'RequestExcelModelDocumentAsyncV2', oRequestInput, {
            query: { variableListName: variableListName, documentName: documentName, isUploadData: isUploadData },
            retryCallback: function () { return _this.requestExcelDocument(oRequestInput, variableListName, documentName, isUploadData); },
        });
    };
    FormService.prototype.getSlideNotes = function (versionId) {
        var _this = this;
        return this.jsonApiService.get('FormService', 'GetSlideNotes', {
            query: { versionId: versionId },
            retryCallback: function () { return _this.getSlideNotes(versionId); },
        });
    };
    FormService.prototype.getSlideNotesByBlobId = function (blobId, slideId) {
        var _this = this;
        return this.jsonApiService.get('FormService', 'GetSlideNotesByBlobIdAndSlideId', {
            query: { blobId: blobId, slideId: slideId },
            retryCallback: function () { return _this.getSlideNotesByBlobId(blobId, slideId); },
        });
    };
    FormService.prototype.getSlideReferenceThumbnails = function (formId, slideGroupOrSectionId, externalSlideVersionId) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                return [2 /*return*/, this.jsonApiService.get('FormService', 'GetSlideGroupOrSectionSlideReferenceThumbnails', {
                        query: { formId: formId, slideGroupOrSectionId: slideGroupOrSectionId, externalSlideVersionId: externalSlideVersionId },
                        retryCallback: function () { return _this.getSlideReferenceThumbnails(formId, slideGroupOrSectionId, externalSlideVersionId); },
                    })];
            });
        });
    };
    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
    FormService.prototype.sendLogToServer = function (log) {
        var _this = this;
        return this.jsonApiService.post('FormService', 'SaveFormLoadTraceEvent', log, {
            retryCallback: function () { return _this.sendLogToServer(log); },
        });
    };
    FormService.isWorkspace = function () {
        var _a;
        var routeName = (_a = index_1.instance.navigator.getRouteName()) !== null && _a !== void 0 ? _a : '';
        return routeName.indexOf('.workspace') >= 0;
    };
    var FormService_1;
    FormService = FormService_1 = __decorate([
        CommonService_decorator_1.CommonService('FormService'),
        __metadata("design:paramtypes", [JsonApi_service_1.JsonApiService,
            User_service_1.UserService,
            Http_service_1.HttpService,
            Cache_service_1.CacheService])
    ], FormService);
    return FormService;
}());
exports.FormService = FormService;
//# sourceMappingURL=Form.service.js.map